var balloonTemplate = require('./Balloon.ejs');
var $ = require('jquery');
var ol = require('openlayers');

module.exports = {

    showBalloon: function(options){
        var that = this,
            defOptions = {
                'content': '',
                'class'  : '',
                'autoPan': true,
                'autoPanAnimation': {
                    duration: 500
                },
                'offset'     : [0,-12],
                'positioning': 'bottom-center',
                'closeTitle' : that.Lang.translate('Закрыть')
            },
            $element,
            position;

        that.hideBalloon();

        options = $.extend(defOptions, options);

        position = ol.proj.transform(options.position, 'EPSG:4326', 'EPSG:3857');
        // options['position'] = position;

        $element = $(balloonTemplate(options));
        $element
            .addClass(options['class'])
            .on('click', '.omjs-popup-closer', function(e){
                e.preventDefault();
                that.hideBalloon();
                return false;
            })
            .find('.omjs-popup-content')
            .append(options['content']);

        options['element'] = $element[0];

        that._balloon = new omjs.ol.Overlay(options);
        that._map.addOverlay(that._balloon);
        that._balloon.setPosition(position);
        that.fire('showBalloon', {
            balloon: that._balloon
        });
        return that._balloon;
    },

    hideBalloon: function(){
        var that = this;
        if(that._balloon){
            that._balloon.setPosition(undefined);
            that._map.removeOverlay(that._balloon);
            that._balloon = undefined;
            that.fire('hideBalloon')
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/View/Balloon.js
// module id = 242
// module chunks = 0